import * as React from 'react';
import If from 'components/If';
import NoWebLogo from 'assets/common/noWebLogo.svg';

type ImageType = Omit<
  React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >,
  'src'
> & {
  src: string;
  defaultImg?: string;
};

function Img(props: ImageType) {
  const {
    src,
    defaultImg = NoWebLogo,
    alt = 'logo',
    width = 24,
    height = 24,
    ...rest
  } = props;
  const [path, setPath] = React.useState(src);

  const handleError = React.useCallback(() => {
    setPath(defaultImg);
  }, [setPath]);

  return (
    <If condition={!!path}>
      <img
        src={path}
        alt={alt}
        width={width}
        height={height}
        onError={handleError}
        {...rest}
      />
    </If>
  );
}

export default Img;
